window.CadastroPFPage={
    data: {
        isEmailValid : false,
        email: "",
        formHandler: null
    },
    get: function (ev) {
        return eval("CadastroPFPage.data."+ev);
    },
    watch: {
        required: ($refField,$refSpan) => {
            if(!FormGenericValidator.required($refField.val())){
                BSForm.error($refField,$refSpan,"Este campo deve ser preenchido");
                return false;
            }
            else return true;
        },
        email: (val) => {
            return new Promise(resolve => {

                $("#formCadastroPF #email").val(val.toLowerCase());
                if (CadastroPFPage.watch.required($('#email'), $('#spanEmailErro'))) {
                    if (FormGenericValidator.email(val)) {
                        if (val != CadastroPFPage.get('email')) {
                            $('#emailSpinner').css({display: "inline-block"});
                            FormGenericValidator.emailExists(val,urls.validate_email,'create').then((isValid) => {
                                $('#emailSpinner').hide();
                                if (isValid) {
                                    BSForm.success($("#email"),$("#spanEmailErro"));
                                }
                                else {
                                    BSForm.error($("#email"),$("#spanEmailErro"),"E-mail já cadastrado na Benfeitoria");
                                }
                                CadastroPFPage.data.email=val;
                                CadastroPFPage.data.isEmailValid=isValid;

                                resolve(true);
                            });
                        }else resolve(CadastroPFPage.get('isEmailValid'));
                    }
                    else {
                        BSForm.error($("#email"), $("#spanEmailErro"), "E-mail inválido");
                        resolve(false);
                    }
                }
                else resolve(false);
            });
        },
        birthday: (date) => {
            if(!CadastroPFPage.watch.required($('#birthday'),$('#spanNascimentoErro'))) return false;
            else{
                if(FormGenericValidator.birthday(date)){
                    let date_formated=Utils.formatDate(date.toString());
                    if(FormGenericValidator.dateValid(date_formated)) {
                        if (
                            FormGenericValidator
                                .dateGreater(
                                    date_formated,
                                    Utils.formatDate(current_date)
                                ) == 1
                            ) {
                            BSForm.error($("#birthday"), $("#spanNascimentoErro"), "Preencha com uma data anterior a data atual");
                        }
                        else {
                            BSForm.success($("#birthday"), $("#spanNascimentoErro"));
                            return true;
                        }
                    }else {
                        BSForm.error($("#birthday"), $("#spanNascimentoErro"), "Preencha com uma data válida");
                    }
                    return false;
                }else{
                    BSForm.error($("#birthday"),$("#spanNascimentoErro"),"Digite o seu nascimento no formato DD/MM/YYYY");
                    return false;
                }
            }
        },
        name: (val) => {
            if(!CadastroPFPage.watch.required($('#nome'),$('#spanNomeErro'))) return false;
            else{
                if(val.toString().trim().length<3){
                    BSForm.error($('#nome'),$('#spanNomeErro'),'O nome deve conter ao menos 3 caractéres.');
                    return false;
                }
                else{
                    BSForm.success($('#nome'),$('#spanNomeErro'));
                    return true;
                }
            }
        },
        password: (password) => {
            if(!CadastroPFPage.watch.required($('#senha'),$('#spanSenhaErro'))) return false;
            else if(FormGenericValidator.password(password)){
                if($('#csenha').val().length>0) {
                    if (FormGenericValidator.passwordConfirm($("#senha").val(), $("#csenha").val()))
                        BSForm.success($("#csenha"), $('#spanSenhaConfirmaErro'));
                    else
                        BSForm.error(
                            $("#csenha"),
                            $('#spanSenhaConfirmaErro'),
                            "A confirmação deve ser igual a senha digitada anteriormente"
                        );
                }
                BSForm.success($("#senha"),$('#spanSenhaErro'));
                return true;
            }else{
                BSForm.error($("#senha"),$('#spanSenhaErro'),"A senha deve conter no mínimo 6 caractéres");
                return false;
            }
        },
        passwordConfirm: (password,password_confirmation) => {
            if(!CadastroPFPage.watch.required($('#csenha'),$('#spanSenhaConfirmaErro'))) return false;
            else if(FormGenericValidator.passwordConfirm(password,password_confirmation)){
                BSForm.success($("#csenha"),$('#spanSenhaConfirmaErro'));
                return true;
            }else{
                BSForm.error($("#csenha"),$('#spanSenhaConfirmaErro'),"A confirmação deve ser igual a senha digitada anteriormente");
                return false;
            }
        },
        country: (val,CHECK_ONLY) => {
            let phoneBlock = $('#inputTelefoneResidencial');

            if(CadastroPFPage.watch.required($("#country"),$("#spanCountryErro"))){
                $("#countrySpinner").css({
                    display: "inline-block"
                });
                BSForm.success($('#country'),$('#spanCountryErro'));
                if(typeof CHECK_ONLY == "undefined") {
                    if (val == 5) {
                        $.ajax({
                            url: urls.load_states,
                            method: "GET",
                            async: false,
                            success: (data) => {
                                $("#stateSelect").html(data);
                                $("#stateSelectWrapper").show();
                                $('#stateInputWrapper,#cityInputWrapper').hide();
                                phoneBlock.show;
                            },
                            error: (e) => {
                                alert("ERRO AO CARREGAR ESTADOS");
                                console.log(e);
                            }
                        });
                    } else {
                        $("#stateSelectWrapper,#citySelectWrapper").hide();
                        $('#stateInputWrapper,#cityInputWrapper').show();
                        phoneBlock.hide();
                    }
                }
                $("#countrySpinner").hide();
                return true;
            }
            else {
                $("#stateSelectWrapper,#stateInputWrapper,#citySelectWrapper,#cityInputWrapper").hide();
                return false;
            }
        },
        state: function (type,CHECK_ONLY) {
            if(type=="select"){
                if(CadastroPFPage.watch.required($("#stateSelect"),$("#spanStateErro"))){
                    BSForm.success($("#stateSelect"),$('#spanStateErro'));
                    $('#stateSpinner').css({display: "inline-block"});
                    if(typeof CHECK_ONLY == "undefined") {
                        $.ajax({
                            url: urls.load_cities + "/" + $("#stateSelect").val(),
                            method: "GET",
                            async: false,
                            success: (data) => {
                                $("#citySelect").html(data);
                                $('#citySelectWrapper').show();
                            },
                            error: (e) => {
                                alert("ERRO AO CARREGAR CIDADES");
                                console.log(e);
                            }
                        });
                    }
                    $('#stateSpinner').hide();
                    return true;
                }else {
                    $('#citySelectWrapper').hide();
                    return false;
                }
            }
            else if(type == "input"){
                if(CadastroPFPage.watch.required($("#stateInput"),$("#spanNewStateErro"))){
                    BSForm.success($("#stateInput"),$("#spanNewStateErro"));
                    return true
                }
                else return false;
            }
            else return false;
        },
        city: function (type) {
            if(type=="select"){
                if(CadastroPFPage.watch.required($("#citySelect"),$("#spanCityErro"))){
                    BSForm.success($("#citySelect"),$("#spanCityErro"));
                    return true;
                }else return false;
            }
            else if(type == "input"){
                if(CadastroPFPage.watch.required($("#cityInput"),$("#spanNewCityErro"))){
                    BSForm.success($("#cityInput"),$('#spanNewCityErro'));
                    return true
                }
                else return false;
            }
            else return false;
        },
        form_send: () => {
            CadastroPFPage.watch.email($("#email").val()).then((emailIsValid) => {
                if(
                    emailIsValid &
                    CadastroPFPage.watch.birthday($("#birthday").val()) &
                    CadastroPFPage.watch.name($("#nome").val()) &
                    CadastroPFPage.watch.password($("#senha").val()) &
                    CadastroPFPage.watch.passwordConfirm($("#senha").val(),$('#csenha').val()) &
                    CadastroPFPage.watch.country($("#country").val(),"CHECK_ONLY") &
                    CadastroPFPage.watch.state(($("#country").val() == 5)?'select':'input',"CHECK_ONLY") &
                    CadastroPFPage.watch.city(($("#country").val() == 5)?'select':'input')
                ){
                    $("#formCadastroPF").unbind("submit",CadastroPFPage.data.formHandler);
                    $('#formCadastroPF').submit();
                }
                else{
                    BSButton.dismiss($('#btnCriar,#btnCriarMobile'));
                }
            }).catch(() => {
                BSButton.dismiss($('#btnCriar,#btnCriarMobile'));
            });
        }
    },
    load: function () {
        let self=this;
        $('#birthday').mask('99/99/9999');
        /*
        * EVENTS LIST
         */
        $('#formCadastroPF #nome').on('blur',function(){
            self.watch.name($(this).val());
        });
        $('#formCadastroPF #email').on('blur',function(){
            self.watch.email($(this).val());
        });
        $('#formCadastroPF #senha').on('blur',function(){
            self.watch.password($(this).val());
        });
        $('#formCadastroPF #csenha').on('blur',function(){
            self.watch.passwordConfirm($("#senha").val(),$(this).val());
        });
        $('#formCadastroPF #birthday').on('blur',function () {
            self.watch.birthday($("#birthday").val());
        });
        $('#formCadastroPF #country').on('change',function () {
            self.watch.country($("#country").val());
        });
        $('#formCadastroPF #stateSelect').on('change',function () {
            self.watch.state("select");
        });
        $('#formCadastroPF #stateInput').on('blur',function () {
            self.watch.state("input");
        });
        $('#formCadastroPF #citySelect').on('change',function () {
            self.watch.city("select");
        });
        $('#formCadastroPF #cityInput').on('blur',function () {
            self.watch.city("input");
        });
        CadastroPFPage.data.formHandler=function (e) {
            e.preventDefault();
            BSButton.loading($('#btnCriar,#btnCriarMobile'));
            self.watch.form_send();
        };
        $("#formCadastroPF").submit(CadastroPFPage.data.formHandler);
        /*
        * END OF EVENTS LIST
         */
    }
};
CadastroPFPage.load();